import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from './app';
import api from './api';
import API_URL from '../config/ApiUrl';

const TotalNumberByAttributesReportSlice = createSlice({
  name: 'TotalNumberByAttributesReportSlice',
  initialState: {},
  reducers: {},
});

export const addTotalNumberByAttributesReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const {
        phone_number,
        number_type,
        state,
        payment_type,
        service_type,
        subscription_type,
      } = payload || {};

      // Ensure `request_id` is included in the payload
      const requestBody: any = {
        phone_number,
        number_type,
        state,
        payment_type,
        service_type,
        subscription_type,
      };

      // Make the API request with the constructed body
      const res = await api.post(
        API_URL.TOTAL_NUMBER__BY_ATTRIBUTES_REPORTS.ADD,
        requestBody,
      );
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListTotalNumberByAttributesReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        phone_number = '',
        number_type = '',
        state = '',
        payment_type = '',
        service_type = '',
        subscription_type = '',
        current = 1,
        page_size = 10,
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `phone_number=${phone_number}`,
        `number_type=${number_type}`,
        `state=${state}`,
        `payment_type=${payment_type}`,
        `service_type=${service_type}`,
        `subscription_type=${subscription_type}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      // Join query parts
      const action = `?${actionParts.join('&')}`;

      // Make the API call
      const response = await api.get(
        API_URL.TOTAL_NUMBER__BY_ATTRIBUTES_REPORTS.LIST + action,
      );

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteTotalNumberByAttributesReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.TOTAL_NUMBER__BY_ATTRIBUTES_REPORTS.DELETE,
        payload,
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default TotalNumberByAttributesReportSlice.reducer;
